import { render, staticRenderFns } from "./visualizarReactivos.vue?vue&type=template&id=6f2b42a6&scoped=true&"
import script from "./visualizarReactivos.vue?vue&type=script&lang=js&"
export * from "./visualizarReactivos.vue?vue&type=script&lang=js&"
import style0 from "./visualizarReactivos.vue?vue&type=style&index=0&id=6f2b42a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2b42a6",
  null
  
)

export default component.exports